import { render, staticRenderFns } from "./item-order.vue?vue&type=template&id=73f42705&scoped=true&"
import script from "./item-order.vue?vue&type=script&lang=js&"
export * from "./item-order.vue?vue&type=script&lang=js&"
import style0 from "@/styles/common.scss?vue&type=style&index=0&id=73f42705&prod&lang=scss&scoped=true&"
import style1 from "./item-order.vue?vue&type=style&index=1&id=73f42705&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f42705",
  null
  
)

export default component.exports